import Service from "../Service";

const resource = "general/positionperson/";

export default {
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    list(requestID) {
        return Service.post(resource + "GetAllUsersDirectoryActive", {}, {
            params: { requestID: requestID },
        });
    }




};